module.exports = __webpack_public_path__ + "static/media/MGRT_SLO-velik.be4a759d.jpg";